import { render, staticRenderFns } from "./index.vue?vue&type=template&id=545461c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=545461c8&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=545461c8&prod&lang=scss"
import style2 from "./index.vue?vue&type=style&index=2&id=545461c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545461c8",
  null
  
)

export default component.exports